import { render, staticRenderFns } from "./ChooseMethod.vue?vue&type=template&id=9da66952&scoped=true&lang=pug"
import script from "./ChooseMethod.vue?vue&type=script&lang=js"
export * from "./ChooseMethod.vue?vue&type=script&lang=js"
import style0 from "./ChooseMethod.vue?vue&type=style&index=0&id=9da66952&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da66952",
  null
  
)

export default component.exports